export default __webpack_public_path__ + "static/media/15.31153e78.png";